export enum MuslimHubRouteName {
    Registration = 'muslim-hub-registration',
    RegistrationVerification = 'muslim-hub-registration-verification',
    ActivityApproval = 'muslim-hub-activity-approval',
    ApprovalVerification = 'muslim-hub-approval-verification',
    AreaApproval = 'muslim-hub-area-approval',
    AreaApprovalVerification = 'muslim-hub-area-approval-verification',
    CreatorManagement = 'muslim-hub-creator-management',
    CreatorDetail = 'muslim-hub-creator-detail',
    CreatorDetailProfile = 'muslim-hub-creator-detail-profile',
    CreatorDetailAgenda = 'muslim-hub-creator-detail-agenda',
    CreatorDetailRating = 'muslim-hub-creator-detail-rating',
    CreatorDetailPlace = 'muslim-hub-creator-detail-place'
}
